import React from "react";
import { useTranslation } from 'react-i18next';
import { Container } from "react-bootstrap";

const ImpressumScreen = () => {
  const { t } = useTranslation();

  return (
    <Container className="pb-3">
      <h3 className="py-4">{t('impressum_title')}</h3>
      
      <section className="pb-2">
        <h5>{t('company_name')}</h5>
        <p>{t('company_name_description')}, Eike-von-Repkow-Str. 39 26121 Oldenburg</p>
      </section>
      
      <section className="pb-2">
        <h5>{t('legal_representative')}</h5>
        <p>Luci Ana Rottweiler</p>
      </section>
      
      <section className="pb-2">
        <h5>{t('contact_details')}</h5>
        <p>{t('contact_email_description')}: contact@lmbrasil.com | {t('contact_phone_description')}: +49 0176 57913422</p>
      </section>
      
      <section className="pb-2">
        <h5>{t('company_registration_number')}</h5>
        <p>{t('company_registration_number_description')}</p>
      </section>
      
      <section className="pb-2">
        <h5>{t('tax_id')}</h5>
        <p>{t('tax_id_description')}</p>
      </section>
    </Container>
  );
};

export default ImpressumScreen;
